import { defineMessages, MessageDescriptor } from "react-intl";

import { Activity, EntityType } from "@mapmycustomers/shared/types/entity";

const checkInRecordTypeMessages = defineMessages({
  company: {
    id: "activity.checkIn.companyRequired",
    defaultMessage:
      "This check-in was created with a company, so a valid company must still be associated to the activity.",
    description: "Error when editing a company check-in activity and removing the company",
  },
  person: {
    id: "activity.checkIn.personRequired",
    defaultMessage:
      "This check-in was created with a person, so a valid person must still be associated to the activity.",
    description: "Error when editing a person check-in activity and removing the person",
  },
});

// v0365 fires when a check-in loses the record type it was created with; map it to a message
// naming that type so the user knows which association to restore. Undefined for non-check-ins.
const getCheckInRecordTypeErrorMap = (
  checkInType: Activity["checkInType"]
): Record<string, MessageDescriptor> | undefined => {
  const message =
    checkInType === EntityType.COMPANY
      ? checkInRecordTypeMessages.company
      : checkInType === EntityType.PERSON
        ? checkInRecordTypeMessages.person
        : undefined;
  return message ? { v0365: message } : undefined;
};

export default getCheckInRecordTypeErrorMap;
